export default __webpack_public_path__ + "static/media/sampleReport1.43cafe77.png";